import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import { PDFReader } from "reactjs-pdf-reader";

import { url } from "../../../../config/config";
import ErrorMessage from "./ErrorMessage/ErrorMessage";
import { useStyles } from "./AdminReadBook.css";
import ControlPanel from "./AdminControlPanel/AdminControlPanel";

class AdminReadBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      fileUrl: "",
      numPages: 0,
      pageNumber: 1,
      desiredPage: "",
      width: 1200,
      errorStatus: false,
      expireError: false,
    };
  }

  componentDidMount() {
    this.getBook(this.props.match.params.bookId);
  }

  getBook = async (bookId) => {
    try {
      const response = await Axios.get(`${url}/api/books/${bookId}`);
      if (response.data.length !== 0) {
        if (response.data.bookFileUrl) {
          const pdfFile = await Axios.get(
            `${url}/api/file/admin/${response.data.bookFileUrl}/${bookId}`,
            {
              headers: {
                "x-auth-token": this.props.adminToken,
              },
            }
          );
          this.setState({
            title: response.data.title,
            fileUrl: pdfFile.data,
          });
        }
      }
    } catch (error) {
      if (error.response.data.errorMessage) {
        this.setState({
          errorStatus: true,
        });
      } else if (error.response.data.expireErrorMessage) {
        this.setState({
          expireError: true,
        });
      }
    }
  };

  handlePageNumber = (page) => {
    this.setState({ pageNumber: parseInt(page) });
  };

  handleNext = () => {
    const currentPageNumber = this.state.pageNumber;
    let nextPageNumber;

    if (currentPageNumber + 1 > this.state.numPages) {
      nextPageNumber = 0;
    } else {
      nextPageNumber = currentPageNumber + 1;
    }

    this.setState({
      pageNumber: nextPageNumber,
    });
  };

  handlePrevious = () => {
    const currentPageNumber = this.state.pageNumber;
    let previousPageNumber;
    if (currentPageNumber - 1 < this.state.numPages) {
      previousPageNumber = 1;
    } else {
      previousPageNumber = currentPageNumber - 1;
    }
    this.setState({
      pageNumber: previousPageNumber,
    });
  };

  handleComplete = (totalPage) => {
    this.setState({
      numPages: totalPage,
    });
  };

  handleEnteredPage = (e) => {
    e.preventDefault();
    this.setState({
      pageNumber: parseInt(this.state.desiredPage),
    });
  };

  render() {
    const { classes } = this.props;
    const { title, fileUrl, pageNumber, numPages, width } = this.state;
    return (
      <div>
        {this.state.errorStatus ||
          (this.state.expireError &&
            (this.state.errorStatus ? (
              <ErrorMessage type="not rented" message="Please Rent book." />
            ) : (
              <ErrorMessage
                type="expired"
                bookId={this.props.match.params.bookId}
                message="Renting days for this book is expired. Renew the renting days or buy the book"
              />
            )))}
        {fileUrl && (
          <div className={classes.root}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ControlPanel
                title={title}
                pageNumber={pageNumber}
                totalPages={numPages}
                handlePageNumber={this.handlePageNumber}
              />
              <br />
              <div className={classes.sectionDesktop}>
                <PDFReader
                  url={decodeURIComponent(fileUrl)}
                  width={width}
                  page={pageNumber}
                  onDocumentComplete={this.handleComplete}
                />
              </div>
              <div className={classes.sectionMobile}>
                <PDFReader
                  url={decodeURIComponent(fileUrl)}
                  width={500}
                  page={pageNumber}
                  onDocumentComplete={this.handleComplete}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.AdminReducer.isAdmin,
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(AdminReadBook));
